/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import Icon from "../../../components/Icon";
import defaultBankImage from "../../../assets/images/bank-card-images/default-bank-img.png";
import defaultCardImage from "../../../assets/images/bank-card-images/default-card-img.png";
import { translation } from "../../../utils/translator";
import { BANK_TYPE } from "../../../constants/BANK_DATA";
import Badge from "../../../components/Badge";
import { ControlTable } from "../../../components/Table";
import { getOverviewBankAccountList, getOverviewCashAccountList, getOverviewTradeSummaries } from "../../../utils/over-view";
import { classnames } from "../../../utils/text";
import { isVerticalImg } from "../../../utils/image";
import { CARD_DATA, CARD_TYPE } from "../../../constants/CARD_DATA";
import { cardName } from "../../../utils/account-name";
import { get, isEmpty } from "lodash";
import { transformComma } from "../../../utils/validator/comma";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { permissionCheck } from "../../../utils/permission";

const FundsOverview = (props) => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [targetPermission, setTargetPermission] = useState(null);
  const [filters] = useState([
    {
      title: '조회기간',
      key: 'date',
      type: 'customdatepicker'
    }
  ]);
  // 매출 매입
  const [tradeStatusFields, setTradeStatusFields] = useState([]);
  const [bankAccountFields] = useState([
    {
      title: "계좌",
      key: "name",
      onValue: (value, field, data) => {
        const { bankCompany, accountNo, bankImg, orgCd } = data;
        return (
          <>
            {!isEmpty(bankCompany) ? (
              <div>
                <Icon className="bank-img-wrap" src={bankImg || defaultBankImage} alt={bankCompany} />
                <Badge
                  className="margin-left-8"
                  color={orgCd === 'pbk' ? "secondary" : 'warning'}
                  size="sm"
                  label={translation(BANK_TYPE, orgCd)}
                />
                <span className="margin-left-8">
                  {`${bankCompany}(${accountNo.substr(accountNo.length - 5)})`}
                </span>
              </div>
            ) : (<>{value}</>)}
          </>
        );
      },
    },
    {
      title: "별칭",
      key: "nickName",
    },
    {
      title: "기초잔액",
      key: "preBalanceAmt",
      type: "comma",
    },
    {
      title: "총 입금액",
      key: "totalInAmt",
      className: "color-red-100",
      type: "comma",
    },
    {
      title: "총 출금액",
      key: "totalOutAmt",
      className: "color-purple-100",
      type: "comma",
    },
    {
      title: "최종 잔액",
      key: "balanceAmt",
      type: "comma",
    },
  ]);
  const [cardAccountFields] = useState([
    {
      title: '신용카드', key: '', onValue: (value, field, data) => {
        const { cardImg, cardCompany, cardNo, orgCd } = data;
        return (
          <>
            <div
              className={classnames("card-img-wrap", {
                vertical: isVerticalImg(cardImg),
              })}
            >
              <img src={cardImg || defaultCardImage} alt={data.cardName} onError={(e) => e.target.src = defaultCardImage} />
            </div>
            <Badge
              className={classnames("card-type-badge", {
                vertical: isVerticalImg(cardImg),
              })}
              color={orgCd === 'card' ? "secondary" : 'warning'}
              size="sm"
              label={translation(CARD_TYPE, orgCd)}
            />
            <span
              className="card-name"
            >
              {cardName(cardCompany || data.cardName, cardNo)}
            </span>
          </>
        );
      }
    },
    {
      title: '별칭',
      key: 'nickName',
    },
    {
      title: '총 승인금액',
      key: 'useAmtSum',
      type: 'comma',
      className: 'color-red-100'
    }
  ]);
  const [cashAccountFields] = useState([
    {
      title: "계좌",
      key: "name",
      onValue: (value, field, data) => {
        const { name } = data;
        return (
          name === "합계" ? (<>{name}</>) :
            <>
              <div>
                <Icon className="bank-img-wrap" src={defaultBankImage} alt={name} />
                <span className="margin-left-8">
                  {name}
                </span>
              </div>
            </>
        );
      },
    },
    {
      title: "기초잔액",
      key: "preBalanceAmt",
      type: "comma",
    },
    {
      title: "총 입금액",
      key: "totalInAmt",
      className: "color-red-100",
      type: "comma",
    },
    {
      title: "총 출금액",
      key: "totalOutAmt",
      className: "color-purple-100",
      type: "comma",
    },
    {
      title: "최종 잔액",
      key: "balanceAmt",
      type: "comma",
    },
  ]);
  const [tradeStatusList, setTradeStatusList] = useState([]);
  const [cardAccountList, setCardAccountList] = useState([]);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [bankResultRow, setBankResultRow] = useState({});
  const [cashAccountList, setCashAccountList] = useState([]);
  const [cashResultRow, setCashResultRow] = useState({});

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_JOURNAL');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_JOURNAL");
      }
    }
  }, [permissions]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    isLoading,
    setIsLoading
  } = useForm(
    {
      date: [getDay(7), getDay()]
    },
  );

  useEffect(() => {
    setTradeStatusFields([
      {
        title: '구분',
        key: 'gubun'
      },
      {
        title: '매출',
        key: 'sales',
        onValue: (value, field, data) => {
          return <a onClick={() => {
            tradeSalesRouteAction(data);
          }} className='color-red-100'>{transformComma(value)}</a>;
        }
      },
      {
        title: '매입',
        key: 'purchases',
        onValue: (value, field, data) => {
          return <a onClick={() => {
            tradePurchaseRouteAction(data);
          }} className='color-purple-100'>{transformComma(value)}</a>;
        }
      }
    ]);
  }, [form]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = async (params) => {
    try {
      setIsLoading(true);
      // 은행계좌 현황
      const bankAccounts = await getOverviewBankAccountList(params);
      setBankAccountList(bankAccounts.bankAccountSummaries);
      setBankResultRow({
        name: '합계',
        preBalanceAmt: bankAccounts.preBalanceAmtSum,
        totalInAmt: bankAccounts.totalInAmtSum,
        totalOutAmt: bankAccounts.totalOutAmtSum,
        balanceAmt: bankAccounts.balanceAmtSum,
      });
      // 현금 계좌현황
      const cashAccounts = await getOverviewCashAccountList(params);
      setCashAccountList(cashAccounts.bankAccountSummaries);
      setCashResultRow({
        name: '합계',
        preBalanceAmt: cashAccounts.preBalanceAmtSum,
        totalInAmt: cashAccounts.totalInAmtSum,
        totalOutAmt: cashAccounts.totalOutAmtSum,
        balanceAmt: cashAccounts.balanceAmtSum,
      });
      // 매출 매입 현황
      const tradeSummaries = await getOverviewTradeSummaries(params);
      const { invoice, taxInvoice, receipt, cashReceipt, cardSummary, paperTaxInvoice } = tradeSummaries;
      setTradeStatusList([
        {
          gubun: '거래명세서',
          path: '/electronic/bill-trade',
          sales: invoice.salesAmtSum,
          purchases: invoice.purchaseAmtSum
        },
        {
          gubun: '세금계산서',
          invoiceType: "tax_invoice",
          path: '/electronic/bill-tax',
          sales: taxInvoice.salesAmtSum,
          purchases: taxInvoice.purchaseAmtSum
        },
        {
          gubun: '계산서',
          path: '/electronic/bill-tax',
          invoiceType: 'invoice',
          sales: receipt.salesAmtSum,
          purchases: receipt.purchaseAmtSum,
        },
        {
          gubun: '현금영수증',
          path: '/electronic/bill-cash',
          sales: cashReceipt.salesSupAmtSum,
          purchases: cashReceipt.purchaseSupAmtSum
        },
        {
          gubun: '신용카드',
          path: '/funds/card-detail',
          sales: cardSummary.salesBuyAmtSum,
          purchases: cardSummary.purchaseUseAmtSum
        },
        {
          gubun: '입금예정액',
          sales: cardSummary.salesPayAmtSum,
          purchases: " "
        },
        {
          gubun: '종이계산서',
          path: '/electronic/bill-paper-tax',
          invoiceType: 'paper-tax-invoice',
          sales: paperTaxInvoice.salesAmtSum,
          purchases: paperTaxInvoice.purchaseAmtSum,
        },
      ]);
      // 카드 현황
      const purchaseCards = get(cardSummary, 'purchaseCards', []);
      if (!isEmpty(purchaseCards)) {
        setCardAccountList(purchaseCards.map((card) => ({
          ...card,
          cardCompany: translation(CARD_DATA, card.cardCd, 'code', 'name')
        })));
      }

    } catch (e) {

    } finally {
      setIsLoading(false);
    }

  };

  const tradeSalesRouteAction = (data) => {
    const { path, invoiceType } = data;
    if (!path) return;
    history.push(`${path}?tab=sales`, {
      ...form,
      ...!isEmpty(invoiceType) ? { invoiceType } : {}
    });
  };

  const tradePurchaseRouteAction = (data) => {
    const { path, invoiceType } = data;
    if (!path) return;
    history.push(`${path}?tab=purchases`, {
      ...form,
      ...!isEmpty(invoiceType) ? { invoiceType } : {}
    });
  };

  // 은행계좌 현황
  const handleOnClickBankList = (data) => {
    const { idx } = data;
    history.push(`/funds/accout-detail?tab=bank-trans`, {
      ...form,
      data: { idx }
    });
  };
  // 카드 현황
  const handleOnClickCardList = (data) => {
    history.push(`/funds/card-detail?tab=purchases`, {
      ...form,
      data
    });
  };
  // 기타거래 현황
  const handleOnClickCashList = (data) => {
    history.push(`/funds/other`, {
      ...form,
      data
    });
  };

  return (
    !isEmpty(targetPermission) && (
      <div className="overview-page">
        <PageHeader title={"자금 일보"} />
        <Filters
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <div className="funds-overview-container">
          <div className="funds-overviw-contents-top">
            <div className="sales-purchases-overview-wrap">
              <ControlTable
                title="매출 매입 현황"
                fields={tradeStatusFields}
                list={tradeStatusList}
                isLoading={isLoading}
              />
            </div>
            <div className="bank-account-wrap">
              <ControlTable
                title="은행계좌 현황"
                fields={bankAccountFields}
                list={bankAccountList}
                resultRow={bankResultRow}
                onSelect={handleOnClickBankList}
                isLoading={isLoading}
              />
            </div>
          </div>
          <div className="funds-overviw-contents-bottom">
            <div className="card-purchases-wrap">
              <ControlTable
                title="카드 현황"
                fields={cardAccountFields}
                list={cardAccountList}
                onSelect={handleOnClickCardList}
                isLoading={isLoading}
              />
            </div>
            <div className="cash-account-wrap">
              <ControlTable
                title="기타거래 현황"
                fields={cashAccountFields}
                list={cashAccountList}
                resultRow={cashResultRow}
                onSelect={handleOnClickCashList}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default FundsOverview;
